import { modalSmsSenderState } from 'Hooks/useModalSmsSender/useModalSmsSender'
import { evalCondition, notifyParent } from 'mailup-react-helpers'
import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Link,
  LINK_VARIANT_EXTRALIGHT
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import { CASE_2, CASE_3, CASE_4, CASE_5, CASE_6 } from '../ModalSmsSender'

const FooterButton = ({
  isTrial,
  items,
  handleCancel,
  caseState,
  handleConfirmCallback
}) => {
  const intl = useIntl()
  const { selectedAlias } = useRecoilValue(modalSmsSenderState)

  const getMainCta = () => {
    switch (caseState) {
      case CASE_2:
      case CASE_3:
        return 'Load.SmsAliasSelector.ModalSenderMainCTA'
      case CASE_5:
        return 'Load.WarningAliasSms.linkAlias'
      case CASE_4:
        return 'Load.WarningAlias.ModalSendersBuyAction'
      default:
        break
    }
  }

  const visibleMainCta = () => {
    switch (caseState) {
      case CASE_2:
      case CASE_3:
      case CASE_4:
        return true
      case CASE_5:
        return evalCondition('co:SMSALIAS AND uo:SETTINGS')
      case CASE_6:
        return false
      default:
        break
    }
  }

  const getSecondaryCta = () => {
    switch (caseState) {
      case CASE_2:
      case CASE_3:
      case CASE_5:
        return 'Load.MailupCommon.Cancel'
      case CASE_4:
        return 'Load.SmsAliasDetail.MoreInfo'
      case CASE_6:
        return ''
      default:
        break
    }
  }

  const visibleSecondaryCta = () => {
    switch (caseState) {
      case CASE_2:
      case CASE_3:
      case CASE_4:
        return true
      case CASE_5:
        return evalCondition('co:SMSALIAS AND uo:SETTINGS')
      case CASE_6:
        return false
      default:
        break
    }
  }

  const handleConfirm = (e) => {
    switch (caseState) {
      case CASE_2:
      case CASE_3:
        // callback esterna
        handleConfirmCallback(e, selectedAlias)
        break
      case CASE_4:
        notifyParent('redirectMainFrame', [
          '/console/mshop_redirector.aspx?t=mshopem'
        ])
        break
      case CASE_5:
        notifyParent('redirectMainFrame', [
          '/console/settings_app_redirector.aspx?r=/settings/smsalias/0'
        ])
        break
      case CASE_6:
        return false
      default:
        break
    }
  }

  return (
    <>
      {visibleSecondaryCta() && (
        <>
          {caseState !== 5 && (
            <Button
              kind={BUTTON_VARIANT_SECONDARY}
              onClick={handleCancel}
              data-mu-test='modal-sms-sender-button-cancel'
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
            </Button>
          )}

          {caseState === 5 && (
            <Link
              variant={LINK_VARIANT_EXTRALIGHT}
              onClick={handleCancel}
              data-mu-test='modal-sms-sender-link-cancel'
            >
              {intl.formatMessage({ id: getSecondaryCta() })}
            </Link>
          )}
        </>
      )}
      {visibleMainCta() && (
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleConfirm}
          data-mu-test='modal-sms-sender-button-confirm'
          disabled={!selectedAlias && caseState !== 5}
        >
          {intl.formatMessage({
            id: getMainCta()
          })}
        </Button>
      )}
    </>
  )
}

FooterButton.propTypes = {
  isTrial: PropTypes.bool,
  items: PropTypes.array,
  handleCancel: PropTypes.func,
  handleConfirmCallback: PropTypes.func,
  caseState: PropTypes.number
}

export default FooterButton
